//=======================| App Configuration |========================//
let d = new Date();

export default {
  appLogo: "/static/images/logo.png",
  appLogoDark: "/static/images/logo.png", // App Logo,
  searchIcon: "/static/images/footer/search.png",
  pageTitle: "TradeBridge - Wholesale Agri Market Place",
  cartIcon: "/static/images/footer/cart-icon.png",
  addwishicon: "/static/images/products/Wish–1.png",
  removewishicon: "/static/images/products/Wish.png",
  brand: "TradeBridge", // Brand Name
  copyrightText:
    "Orchestrade Technologies Pvt Ltd. " +
    d.getFullYear() +
    ". All Rights Reversed", // Copyright
  // Single source for statutory identity.
  company: {
    legalName: "Orchestrade Technologies Pvt Ltd",
    brand: "TradeBridge",
    addressLines: [
      "Arihant Aura, Floor No. 18, Plot No 13/1,",
      "TTC Industrial Area, Thane Belapur Road,",
      "Navi Mumbai - 400706,",
      "Maharashtra, India",
    ],
    gstin: "27AADCO6874E1Z7",
    fssai: "11522998001869",
    dpiit: "DIPP106040",
    // Certificate PDFs for each registration.
    docs: {
      gstin:
        "https://ashapura.s3.ap-south-1.amazonaws.com/api/order/06ec4c0d-b4f7-4fc7-b347-8643622f8fc3.pdf",
      fssai:
        "https://ashapura.s3.ap-south-1.amazonaws.com/api/order/6e2053aa-0c6f-4b66-9ca9-2cb0bdaeddae.pdf",
      dpiit:
        "https://ashapura.s3.ap-south-1.amazonaws.com/api/order/f65b56c1-08a3-4024-afa8-c01705db91b1.pdf",
    },
  },
  color: {
    primary: "#3C9900",
    accent: "#3C9900",
  },
  webVersion: "1.7.0",
  baseApiURL: process.env.VUE_APP_BASE_API,
  appStore: "https://apps.apple.com/in/app/tradebridge/id1522137937",
  playStore:
    "https://play.google.com/store/apps/details?id=com.ashapura.tradebridge&hl=en&gl=IN",
  showLang: false,
  whatsAppOrderMobileNumber: 8657394820,
};
